module.exports = __webpack_public_path__ + "images/offer-black-placeholder.8f19e631.png";